'use client'
import React, { HTMLAttributes, ReactElement, useEffect } from 'react'
import { getPaneTypeClassModifier } from './helpers/get-pane-type-class-modifier'
import { LayoutSidebarPaneType } from './types-and-constants/LayoutPaneTypesAndConstants'
import { useLayoutContext } from '../../../../providers/layout-provider'
import { getRetainBehaviorModifierForPane } from '../helpers/get-retain-behavior-for-pane'
import { Retain } from '../../../atoms/Retain/Retain'
import { RetainBehaviorModifier } from '../../../atoms/Retain/constants/modifiers'

interface Props extends HTMLAttributes<HTMLDivElement> {
    children?: ReactElement | ReactElement[]
    paneType: LayoutSidebarPaneType
    customRetainBehaviorModifier?: RetainBehaviorModifier
}

/**
 * @deprecated Prefer LayoutSidebarPaneRSC
 * */
export const LayoutSidebarPane = ({
    paneType,
    children,
    customRetainBehaviorModifier,
    ...props
}: Props): ReactElement => {
    const layoutContext = useLayoutContext()
    const { sidebarState, setSidebarState } = layoutContext

    if (!paneType && !sidebarState.paneType) {
        console.error('paneType is required for the Layout to read it.')
    }

    useEffect(() => {
        if (!!paneType) {
            setSidebarState({ ...sidebarState, paneType })
        }
    }, [paneType])

    return (
        <div
            {...props}
            className={`o-layout__sidebar o-layout__sidebar--${getPaneTypeClassModifier(
                sidebarState.paneType ?? paneType,
            )} ${props.className ?? ''}`}
        >
            <Retain
                behaviorModifiers={[
                    customRetainBehaviorModifier ?? getRetainBehaviorModifierForPane(paneType, layoutContext),
                ]}
                className="h-full"
                behaviorOnly
            >
                {sidebarState.children ?? children ?? <></>}
            </Retain>
        </div>
    )
}
